import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="w-full px-4 md:px-8 py-24 md:py-32 flex flex-col items-center text-center">
      <span className="font-heading text-6xl md:text-8xl font-semibold text-primary-200 select-none">
        404
      </span>
      <h1 className="mt-6 font-heading text-2xl md:text-3xl font-semibold text-foreground-950">
        页面走失了
      </h1>
      <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-md leading-relaxed">
        你要找的页面不存在或已被移除。不如回到首页，继续探索那些经典的仙侠故事。
      </p>
      <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="inline-flex items-center gap-2 h-11 px-6 rounded-md bg-primary-700 hover:bg-primary-600 text-background-50 text-sm font-medium whitespace-nowrap transition-colors"
        >
          <i className="ri-home-4-line"></i>
          返回首页
        </Link>
        <Link
          to="/category"
          className="inline-flex items-center gap-2 h-11 px-6 rounded-md border border-background-300 text-foreground-800 hover:border-primary-400 hover:text-primary-700 text-sm font-medium whitespace-nowrap transition-colors"
        >
          <i className="ri-film-line"></i>
          浏览剧集分类
        </Link>
      </div>
    </div>
  );
}